// What the server painted into the <head>, read once,
// synchronously, out of the gwmc:* meta tags the layout writes on every render
// (app/views/layouts/gwmc.html.haml, fed by MetaTags::Helper).
//
// This is the same single source the rebuilt hero and the home page's
// whats-included section read, and it is the reason /services no longer bakes
// "£69" into the bundle: a price written into JavaScript goes stale and
// nobody notices. client/gwmc/store/constants/prices.js once carried a
// 420-line copy of the catalogue still claiming Mini Valet £49.
//
// TWO TAGS NOW, AND THE SECOND ONE IS THE LIST ITSELF.
//
//   gwmc:prices   `{ <booking slug>: "£69" }` for the six washes plus every
//                 surcharge in the catalogue: `large_car`,
//                 `congestion_zone` and, since 5 October 2026,
//                 `anytime_today`. What the hero and the final CTA read.
//   gwmc:catalogue  `{ washes: [{ slug, key, name, price }], add_ons: 21 }`:
//                 WHICH washes /services compares, in the order it compares
//                 them, and how many add-ons go with them. Added 5 October
//                 2026, when /services stopped holding its own array of six
//                 wash names and 21 add-on names in the bundle. A wash retired
//                 in the database is not in here and the table draws no column
//                 for it. MetaTags::Helper#fold_catalogue.
//
// Both are in the HTML rather than fetched because the comparison table is
// /services' own content and its first paint. The 21 add-ons are NOT on either
// tag: they come from /api/v2/services through lib/use-published-catalogue.js
// in the extras section, which is below the fold and after the table has
// painted.
//
// THIS IS THE HOME OF readPrices, as of 5 October 2026. It lived in
// pages/services/ and three other files had their own copy of the same six
// lines; it was flagged there and moved here, because the tags it reads are
// written on every route and not only on /services. lib/home-title.js reads
// the catalogue through it, and sections/hero/index.js and
// sections/whats-included/index.js still carry their own readPrices.
export const readMeta = (name, fallback) => {
  if (typeof document === 'undefined') return fallback

  const tag = document.querySelector(`meta[name='${name}']`)

  try {
    return JSON.parse(tag?.getAttribute('content') || 'null') ?? fallback
  } catch (e) {
    return fallback
  }
}

export const readPrices = () => readMeta('gwmc:prices', {})

const readCatalogue = () => readMeta('gwmc:catalogue', {}) || {}

export const readWashes = () => {
  const washes = readCatalogue().washes

  return Array.isArray(washes) ? washes : []
}

// THE "FROM" FIGURE, and it comes off the WASHES and not off `gwmc:prices`.
//
// `gwmc:prices` is keyed by booking slug and carries the surcharges beside the
// six washes, so the minimum over its values is "Congestion Zone adds £18".
// pages/home/sections/areas-cta read it that way until 5 October 2026 and the
// closing call to action on every home and area page said "Book a wash from
// £18", which is £51 under the cheapest thing we sell. `gwmc:catalogue`
// carries only the washes, which is the same six services
// MetaTags::Helper#lowest_base_price takes its own minimum over
// (CustomerServices::BOOKABLE_BASE_KEYS), so the figure here is the server's
// figure.
//
// "£1,234.50" -> 1234.5. The server formats the amount; the only thing to do
// with it here is compare two of them, and a string compare puts "£125.93"
// below "£69".
const poundsOf = price => Number(String(price).replace(/[^0-9.]/g, ''))

// The cheapest wash, as the string the server sent. Null when nothing we can
// price was published, which is the one case every caller has to handle rather
// than fall back: a wrong price in a search result or on a button is a refund
// conversation.
export const lowestWashPrice = (washes = []) => {
  const prices = (Array.isArray(washes) ? washes : [])
    .map(wash => wash && wash.price)
    .filter(price => typeof price === 'string' && poundsOf(price) > 0)

  if (prices.length === 0) return null

  return prices.reduce((a, b) => (poundsOf(a) <= poundsOf(b) ? a : b))
}

export const readLowestWashPrice = () => lowestWashPrice(readWashes())

// How many add-ons the page lists, for the sentence under the H1. A count and
// not a list: the two add-on cards are built from /api/v2/services, below the
// fold, and this sentence is in the first screen. null when the server has not
// said, which the sentence handles rather than guessing.
export const readAddOnCount = () => {
  const count = readCatalogue().add_ons

  return typeof count === 'number' && count > 0 ? count : null
}
